export var Countries;
(function (Countries) {
    Countries["DE"] = "DE";
    Countries["AT"] = "AT";
})(Countries || (Countries = {}));
